import React from "react";
import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Tabs,
	Tab
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from 'prop-types';
import { Availability } from "./availability";
import { DateWiseTrend } from "./dateWiseTrend";
const durationPulgin = require('dayjs/plugin/duration')
dayjs.extend(durationPulgin)


const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}


const getTotalWeekOfCurrentMonth = () => {
	return Math.ceil(dayjs().daysInMonth() / 7)
}

const getWeekOfMonth = () => {
	return dayjs.duration().weeks();
}

export const LeadDashboard2 = (props) => {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
					<Tab label="AGENT AVAILABILITY" {...a11yProps(0)} />
					<Tab label="DATEWISE CALL TREND" {...a11yProps(1)} />

				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0}  >
				<Availability />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}  >
				<DateWiseTrend />
			</CustomTabPanel>
		</Box>
	)
}


